// start:ng42.barrel
export * from './validation-errors.component';
// end:ng42.barrel

